var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":'https://app.chronologic.network/awaiting/scheduler/' + _vm.txHash,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n  "+_vm._s(_vm.linkText ? _vm.linkText : _vm.txHash)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }